import './CustomerCredit.css';
import { useState, useContext } from "react";
import { ApiContext } from "../../Contexts/ApiContext";
import { Loader } from "../Loader/Loader";
import NC_logo from "../../Pages/img/NC_logo.png"
export const CustomerCredit = () => {
  const { getCustomerCredit } = useContext(ApiContext);
  const [dcsInput, setDcsInput] = useState();
  const [creditAmount, setCreditAmount] = useState();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const refreshPage = () => {
    setDcsInput();
    setCreditAmount();
    setError();
  }
  const onFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const resp = await getCustomerCredit(dcsInput);
    if (resp?.data?.availableCredit) {
        setCreditAmount(`${resp?.data?.accountCurrencySymbol}${resp?.data?.availableCredit}`);
    }
    if (resp.status === 500 || 404) {
        setError(resp?.response?.data?.message);
    }
    setIsLoading(false);
    return resp;
  };
  const handleChange = (e) => {
    setDcsInput(e.target.value);
  };
  return (
    <div className="credit-pg-container hurme-3-regular letter-spacing">
        <div className='credit-pg-container'>
          <img src={NC_logo} alt="Nayax Capital Logo" />
          <h1 className='credit-pg-h1'>Nayax Capital</h1>
          <div className='credit-pg-container'>
          <h2 className='credit-pg-h2'>Interest-Free Financing for Your Business </h2>
          <p className='credit-pg-info-p'>Gain access to unprecedented, personalized 0% APR (!) financing offers.</p>
          <p className='credit-pg-info-p padding-top'>Our programs are flexible and will help you scale your business by mitigating the up-front costs of Nayax devices and various machines (vending/change/amusement/coffee etc.)</p>
          <p className='credit-pg-h2 padding-top'><b>We won’t surprise you with:</b>
            <ul className='credit-pg-ul'>
              <li className='credit-pg-li-item'>Additional price markups </li>
              <li className='credit-pg-li-item'>Late penalties </li>
              <li className='credit-pg-li-item'>Hidden costs </li>
              <li className='credit-pg-li-item'>Early payoff fees or any other fees </li>
            </ul>
          </p>
          <p className='credit-pg-info-p'>For unattended businesses of any size. Really, no catch! </p>
          <p className='credit-pg-info-p padding-top'>Focus on your business. Not on your financing. </p>
          <p className='credit-pg-info-p'><b>To redeem your credit, please contact your Nayax UK Acccount Manager.</b></p>
          </div>
        </div>
      {creditAmount && <div className='credit-pg-container'>
        <p className='credit-pg-p'>Your available credit amount</p>
        <p className='credit-pg-p'><span>{creditAmount}</span></p>
        <button onClick={refreshPage} className="accept-btn-bg hurme-3-semibold credit-pg-btn">Back</button>
        </div>}
      {isLoading && <Loader />}
      {error && 
      <p className='credit-pg-p credit-pg-err'>{error}</p>}
      {!creditAmount ? (
        <div className="credit-pg-container">
          <p className='credit-pg-p'>{error ? 'Please try again' : 'Please enter your DCS number'}</p>
          <form onSubmit={onFormSubmit} className="credit-pg-container">
            <input type="text" onChange={handleChange} className='credit-pg-input' />
            <div>
              <button
                className="accept-btn-bg hurme-3-semibold credit-pg-btn"
                type="submit"
                id="login-btn"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
